"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineNode = void 0;
var moment = require("moment");
var milestone_progress_1 = require("../milestone-progress");
var timeline_element_1 = require("./timeline-element");
var TimelineNode = /** @class */ (function () {
    function TimelineNode(props, verbose) {
        if (verbose === void 0) { verbose = false; }
        this.verbose = verbose;
        this.elements = [];
        this.year = new Date().getFullYear();
        this.month = 'january';
        this.updated = new Date().toISOString();
        this.elementsFull = [];
        if (props.elements && props.elements.length > 0) {
            this.elementsFull = props.elements.map(function (element) { return new timeline_element_1.TimelineElement(element); });
        }
        Object.assign(this, props);
        if (!this.year || !this.month) {
            throw new Error('No provided year or month!');
        }
    }
    /**
     * Returns which nodes an element belongs to, organized in starting, ending, and overlapping
     */
    TimelineNode.elementBelongs = function (element, dog) {
        var _a = milestone_progress_1.MilestoneProgress.absoluteTimeframe(element.instance, dog), start = _a.start, end = _a.end;
        var elementStart = moment(start.date.min);
        var elementEnd = moment(end.date.max);
        // count up by month until we reach end
        var offset = 0;
        var range = elementEnd.endOf('month').diff(elementStart.startOf('months'), 'months');
        if (range < 0) {
            throw new Error('Cannot have a negative range');
        }
        var present = elementStart.startOf('month');
        var tick;
        var overlaps = [{
                month: TimelineNode.month(present.month()),
                year: present.year()
            }];
        // Should it be < or <= ?
        while (offset <= range) {
            tick = moment(present)
                .add(offset++, 'month');
            overlaps.push({
                year: tick.year(),
                month: TimelineNode.month(tick.month())
            });
        }
        return {
            start: {
                month: TimelineNode.month(elementStart.month()),
                year: elementStart.year()
            },
            overlaps: overlaps,
            end: {
                month: TimelineNode.month(elementEnd.month()),
                year: elementEnd.year()
            }
        };
    };
    /**
     * Checks if an elements timeline starts, ends, or overlaps a give node
     */
    TimelineNode.elementTimeRelation = function (element, node, dog) {
        // Start of node's month
        var nodeStart = moment()
            .set({ year: node.year, month: TimelineNode.monthIndex(node.month) })
            .startOf('month');
        // End of node's month
        var nodeEnd = moment(nodeStart)
            .endOf('month');
        // Check if min start is between this node's start and end or max end is between this node's start and end
        var _a = milestone_progress_1.MilestoneProgress.absoluteTimeframe(element.instance, dog), start = _a.start, end = _a.end;
        var elementStart = moment(start.date.min);
        var elementEnd = moment(end.date.max);
        // Check if elements starts or ends in this month
        var startValid = elementStart.isBetween(nodeStart, nodeEnd, 'day', '[]');
        var endValid = elementEnd.isBetween(nodeStart, nodeEnd, 'day', '[]');
        // Check Overlap Rules
        // 1. Element Start cannot be after Node End but can be before Node Start (check if element starts after node end)
        // 2. Element End cannot be before Node Start but can be after Node End (check if element end before node start)
        var elementStartAfterNodeEnd = elementStart.isAfter(nodeEnd);
        var elementEndBeforeNodeStart = elementEnd.isBefore(nodeStart);
        // If any above are true, then doesn't overlap
        if (elementStartAfterNodeEnd && elementEndBeforeNodeStart) {
            throw new Error('Impossible! Element cannot start after node end and end before node start!');
        }
        var overlaps = !elementStartAfterNodeEnd && !elementEndBeforeNodeStart;
        return {
            start: startValid,
            end: endValid,
            overlaps: overlaps
        };
    };
    TimelineNode.month = function (index) {
        return TimelineNode.months[index];
    };
    TimelineNode.monthIndex = function (month) {
        return TimelineNode.months.indexOf(month);
    };
    TimelineNode.prototype.reset = function () {
        this.elements = [];
    };
    TimelineNode.prototype.add = function (input, dog) {
        if (input.progress.id !== input.instance.id) {
            throw new Error("Cannot add: progress and instance have mismatched ids, got progress=\"" + input.progress.id + "\" and instance=\"" + input.instance.id + "\", (" + input.instance.name + ")");
        }
        var index = this.elementsFull.findIndex(function (e) { return (e.progress.id === input.progress.id); });
        if (index > -1) {
            try {
                // remove duplicate if any
                this.remove(input.progress.id);
                if (this.verbose) {
                    console.log('Duplicate removed');
                }
            }
            catch (err) {
                if (this.verbose) {
                    console.warn("Nothing to remove for progress " + input.progress.id, err);
                }
            }
        }
        var data = {
            progress: input.progress,
            instance: input.instance,
            updated: new Date().toISOString(),
            icon: timeline_element_1.TimelineElement.getIcon(input.instance.category)
        };
        var element = new timeline_element_1.TimelineElement(data);
        var valid = this.checkRange(element, dog);
        if (!valid) {
            console.error('Invalid Range', element, "Node: " + this.month + "-" + this.year);
            throw new Error("Invalid range for \"" + element.instance.name + "\" on Node " + this.month + "-" + this.year);
        }
        this.elementsFull.push(element);
        this.elements.push(element.toJSON());
    };
    /**
     * This will update an existing progress
     */
    TimelineNode.prototype.update = function (input, dog) {
        if (input.progress.id) {
            var index = this.elementsFull.findIndex(function (e) { return (e.progress.id === input.progress.id); });
            if (index > -1) {
                this.elementsFull[index].progress = __assign(__assign({}, this.elementsFull[index].progress), input.progress);
                this.elements[index] = this.elementsFull[index].toJSON();
            }
            else {
                this.add(input, dog);
            }
        }
        else {
            throw new Error('Progress must have an id');
        }
    };
    TimelineNode.prototype.remove = function (id) {
        var index = this.elementsFull.findIndex(function (e) { return (e.progress.id === id); });
        if (index > -1) {
            this.elementsFull.splice(index, 1);
        }
        else {
            throw new Error("Could not find " + id + " in " + this.month + " " + this.year);
        }
    };
    Object.defineProperty(TimelineNode.prototype, "start", {
        get: function () {
            return moment()
                .set({ year: this.year, month: TimelineNode.monthIndex(this.month) })
                .startOf('month');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimelineNode.prototype, "end", {
        get: function () {
            var start = this.start;
            return moment(start)
                .endOf('month');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimelineNode.prototype, "info", {
        get: function () {
            return this.month + "-" + this.year;
        },
        enumerable: false,
        configurable: true
    });
    TimelineNode.prototype.toJSON = function () {
        return {
            elements: this.elementsFull.map(function (element) { return element.toJSON(); }),
            year: this.year,
            updated: this.updated,
            month: this.month
        };
    };
    /**
     * Checks if milestone progress is between months start and end date
     * @TODO this only validates the milestones start date, need to include overlap
     */
    TimelineNode.prototype.checkRange = function (milestone, dog) {
        var relation = TimelineNode.elementTimeRelation(milestone.toJSON(), this.toJSON(), dog);
        if (this.verbose) {
            console.log(milestone.instance.name + " between " + this.month + "-" + this.year + ":\n\tStart: " + relation.start + "\n\tEnd: " + relation.end + "\nOverlaps: " + relation.overlaps + "\n", milestone);
        }
        return relation.start;
    };
    TimelineNode.months = ['january', 'february', 'march', 'april', 'may', 'june',
        'july', 'august', 'september', 'october', 'november', 'december'
    ];
    return TimelineNode;
}());
exports.TimelineNode = TimelineNode;
